module.exports = __webpack_public_path__ + "img/modeler.a4755a5f.png";